import React, { useEffect } from 'react'

function useListener() {
  useEffect(() => {
    const handleMouseMove = (event) => {
      const cursorInner = document.querySelector(".cursor-inner");
      const cursorOuter = document.querySelector(".cursor-outer");

      if (cursorOuter) {
        cursorOuter.style.transform = `translate(${event.clientX}px, ${event.clientY}px)`;
      }

      if (cursorInner) {
        cursorInner.style.transform = `translate(${event.clientX}px, ${event.clientY}px)`;
      }
    };

    const handleMouseEnter = () => {
      const cursorInner = document.querySelector(".cursor-inner");
      const cursorOuter = document.querySelector(".cursor-outer");

      if (cursorInner) {
        cursorInner.classList.add("s");
      }

      if (cursorOuter) {
        cursorOuter.classList.add("s");
      }
    };

    const handleMouseLeave = (event) => {
      const cursorInner = document.querySelector(".cursor-inner");
      const cursorOuter = document.querySelector(".cursor-outer");

      if (
        event.target.tagName !== "A" ||
        !event.target.closest(".cursor-pointer")
      ) {
        if (cursorInner) {
          cursorInner.classList.remove("cursor-hover");
        }

        if (cursorOuter) {
          cursorOuter.classList.remove("cursor-hover");
        }
      }
    };

    document.body.addEventListener("mousemove", handleMouseMove);
    document.body.addEventListener("mouseenter", handleMouseEnter);
    document.body.addEventListener("mouseleave", handleMouseLeave);

    const cursorInner = document.querySelector(".cursor-inner");
    const cursorOuter = document.querySelector(".cursor-outer");

    if (cursorInner) {
      cursorInner.style.visibility = "visible";
    }

    if (cursorOuter) {
      cursorOuter.style.visibility = "visible";
    }

    return () => {
      document.body.removeEventListener("mousemove", handleMouseMove);
      document.body.removeEventListener("mouseenter", handleMouseEnter);
      document.body.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return ({})
}

export default useListener